export default __webpack_public_path__ + "static/media/Create-documentation.e0318507.md";